import { Users, ClipboardCheck, PhoneCall } from 'lucide-react';

const signals = [
  {
    icon: Users,
    title: 'Ein Ansprechpartner',
    text: 'Pumpe, Transport und Betonverkauf werden gemeinsam abgestimmt.',
  },
  {
    icon: ClipboardCheck,
    title: 'Vor dem Einsatz klar',
    text: 'Menge, Zufahrt, Pumpweg und Timing werden vorab geprüft.',
  },
  {
    icon: PhoneCall,
    title: 'Kurzer Draht',
    text: 'Telefonische Abstimmung ohne lange Umwege.',
  },
];

function SignalStrip() {
  return (
    <section className="relative z-10 -mt-8 sm:-mt-12 mb-0">
      <div className="container-site mx-auto">
        <div className="grid md:grid-cols-3 rounded-card overflow-hidden border border-signal-dark/10 bg-white/90 shadow-elevated backdrop-blur-md">
          {signals.map((signal, index) => (
            <div
              key={signal.title}
              className={`relative p-5 min-h-[110px] sm:min-h-[120px] ${index < signals.length - 1 ? 'border-b md:border-b-0 md:border-r border-ink/10' : ''}`}
            >
              <div className="w-9 h-1 rounded-full bg-signal mb-3" aria-hidden="true" />
              <div className="flex items-start gap-3">
                <signal.icon className="w-5 h-5 text-signal-dark mt-1 flex-shrink-0" />
                <div>
                  <strong className="block text-base font-extrabold mb-1">{signal.title}</strong>
                  <span className="block text-xs sm:text-sm text-ink-soft">{signal.text}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SignalStrip;
